export const formatPriceString = (amount: number, currency: string = 'SEK'): string => {
  const formattedAmount = amount / 100; // Expects amount in cents

  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: currency
  }).format(formattedAmount);
};

export const formatAmountToCents = (amount: number) => {
  return amount * 100;
};

export const formatCentsToAmount = (cents: number) => {
  return cents / 100;
};

export const formatStringToAmountInCents = (amount: string) => {
  const amountWithPeriod = amount.replace(',', '.');
  const amountNumber = isNaN(parseFloat(amountWithPeriod)) ? 0 : parseFloat(amountWithPeriod);
  const amountAsCents = formatAmountToCents(amountNumber);

  return amountAsCents;
};
